import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var CloseIcon = function (_a) {
    var _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "Close Icon" : _b, props = __rest(_a, ["ariaLabel"]);
    return (React.createElement(SvgIcon, __assign({}, props, { ariaLabel: ariaLabel }),
        React.createElement("path", { d: "M13.822 6.184a.604.604 0 00-.855 0L10 9.144 7.033 6.177a.604.604 0 10-.856.856L9.144 10l-2.967 2.967a.604.604 0 10.856.855L10 10.857l2.967 2.966a.604.604 0 10.855-.855L10.857 10l2.966-2.967a.608.608 0 000-.85z" })));
};

export { CloseIcon };
//# sourceMappingURL=CloseIcon.esm.js.map
